import React from 'react'
import Navbar from './Navbar'
import Dropdown from './Dropdown'
import LineChart from './LineChart'
import { useLocation } from 'react-router-dom'
const PerformanceDetails = () => {
    const location = useLocation();
    // const selectedId = location.state?.selectedId;
    const id = location.state?.id;
    const maneuvers = location.state?.maneuverArray;
    const maneuverName = location.state?.maneuverName
    let requiredObject = {};
    // console.log("Printing maneuvers data from props " , maneuvers);
    Object.entries(maneuvers).forEach(([key, value]) => {
        if (key === id) {
            // console.log('printing key and id ', key, " ", id);
            requiredObject = value;
        }
    })
    // console.log("printing required Object ", requiredObject);

    // Step 1: Split the data based on the line separator ##
    const lines = requiredObject.rawData.split("##");

    // Step 2: Parse each line into an array of values
    const parsedData = lines.map(line => line.split(","));

    // Step 3: Extract the timestamp and AltitudeAbsoluteAltitude arrays
    const timestampArray = [];
    const altitudeArray = [];

    parsedData.forEach(line => {
        if (line.length > 1) { // Ensure there are multiple values in the line
            const timestamp = line[0];
            const altitude = line[line.length - 2]; // Assuming AltitudeAbsoluteAltitude is the second last value
            timestampArray.push(timestamp);
            altitudeArray.push(altitude);
        }
    });
    timestampArray.shift();
    altitudeArray.shift();
    
    let updatedAltitudeArray = altitudeArray.map(value => parseFloat(value).toFixed(2));

    function timestampToDateTime(timestamp) {
        let date = new Date(parseInt(timestamp));
        return date.toLocaleString(); // Convert date to local time format
    }

    let dateTimeArray = timestampArray.map(timestampToDateTime);

    // console.log("Timestamp Array:", timestampArray);
    // console.log("AltitudeAbsoluteAltitude Array:", altitudeArray);

    const seriesData = [{
        name : 'Altitude variance',
        data : updatedAltitudeArray
    }]

    // console.log("printing inside performce jsx  ", maneuvers, id);
    return (
        <div style={{overflowY : "hidden"}}>
            <div>
                <Navbar />
            </div>
            <div>
                <h1 className='text-center text-2xl font-semibold mt-5 w-full'>
                    Altitude Variance - {maneuverName}
                </h1>
            </div>
            {/* <div className='flex justify-start items-center bg-gray-800 mx-10 mt-4 py-3 px-8 '>
                <div>
                    <Dropdown data={"Filter By"} />
                </div>
            </div> */}
            <div>
                <div className='flex justify-evenly mt-12'>
                    <div style={{width : "97%", marginRight : "20px"}}>
                        {timestampArray.length > 0 && altitudeArray.length > 0 ? (<LineChart  data={seriesData} categories={dateTimeArray} yAxisLabel="Altitude" xAxisLabel= "TimeStamp" graphName= "Altitude Variance"/>) : (<LineChart/>)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PerformanceDetails